/**
 * 前端兜底数据：当后端接口不可用或返回为空时使用。
 * 命名空间挂载在 this.$apis.fallbackData
 */

// 静态引入，避免动态 require 触发整目录扫描
import PLACEHOLDER from '@/assets/noimg.jpg'
import IMG_GY1 from '@/assets/工业/展示1.png'
import IMG_GY2 from '@/assets/工业/展示2.png'
import IMG_NY_USER from '@/assets/农业/用户端展示.png'
import IMG_NY_EXPERT from '@/assets/农业/专家端展示.png'
import IMG_YL from '@/assets/医疗/展示图.png'
import IMG_TL_PC from '@/assets/铁路/pc端展示.png'
import IMG_TL_MOBILE from '@/assets/铁路/移动端展示.png'
import IMG_DXAL_NY from '@/assets/典型案例/农业.png'
import IMG_DXAL_YL from '@/assets/典型案例/医疗.png'
import IMG_DXAL_GY from '@/assets/典型案例/工业.png'
import IMG_DXAL_TL from '@/assets/典型案例/铁路.png'

const PIC = {
  placeholder: PLACEHOLDER,
  gy1: IMG_GY1, gy2: IMG_GY2,
  nyUser: IMG_NY_USER, nyExpert: IMG_NY_EXPERT,
  yl: IMG_YL,
  tlPc: IMG_TL_PC, tlMobile: IMG_TL_MOBILE,
  dxalNy: IMG_DXAL_NY, dxalYl: IMG_DXAL_YL, dxalGy: IMG_DXAL_GY, dxalTl: IMG_DXAL_TL,
}

// 案例分类
const CLAZZ_LIST = [
  { code: 'AL_AI',   name: 'AI 落地',      pcode: 'AL' },
  { code: 'AL_PMS',  name: 'PMS 酒店',     pcode: 'AL' },
  { code: 'AL_SELF', name: '无人自助',     pcode: 'AL' },
  { code: 'AL_NY',   name: '智慧农业',     pcode: 'AL' },
  { code: 'AL_YL',   name: '医疗信息化',   pcode: 'AL' },
  { code: 'AL_GY',   name: '工业可视化',   pcode: 'AL' },
  { code: 'AL_TL',   name: '铁路调度',     pcode: 'AL' },
]

// 案例条目
const CASE_PAGES = {
  AL_PMS: [
    {
      id: 'pms-001',
      title: '漫云居民宿 · 智慧酒店 PMS 系统',
      clazzCode: 'AL_PMS',
      clazzName: 'PMS酒店行业',
      state: 1,
      cover: PIC.dxalGy,
      content: `
        <h2>项目概述</h2>
        <p>面向中小型连锁酒店、客栈、民宿打造的一站式 PMS（酒店管理）系统。覆盖 <b>预订、入住、退房、收银、财务、客房、清洁、渠道分销</b> 全流程。</p>
        <h3>核心模块</h3>
        <ul>
          <li>多渠道订单聚合（携程 / 美团 / 飞猪 / 抖音 / 自有小程序）</li>
          <li>实时房态地图、批量调房、押金 / 退款一键处理</li>
          <li>会员体系：积分、储值、分销、客户画像</li>
          <li>智能门锁 / 自助入住机：扫码核验身份证，全程无人值守</li>
          <li>移动端：店长、前台、保洁、巡店多角色 App</li>
          <li>数据看板：日报、月报、入住率、RevPAR、ADR</li>
        </ul>
        <h3>客户价值</h3>
        <p>典型客户上线后人工成本下降 <b>35%</b>、夜间入住效率提升 <b>3 倍</b>，OTA 渠道超卖率降为 0。</p>
      `
    },
    {
      id: 'pms-002',
      title: '民宿连锁 · 多店统一管理平台',
      clazzCode: 'AL_PMS',
      clazzName: 'PMS酒店行业',
      state: 1,
      cover: PIC.dxalNy,
      content: `
        <h2>方案简介</h2>
        <p>为云南本地连锁民宿品牌定制的 SaaS 化多店管理平台，总部可统一管控 <b>价格、房型、活动、会员、财务</b>。</p>
        <h3>亮点能力</h3>
        <ul>
          <li>分店独立运营 + 总部集中报表</li>
          <li>动态定价：节假日、淡旺季、库存自动调价</li>
          <li>智能客服机器人：处理常见问询、退改、催付</li>
          <li>对接微信小程序、抖音团购券核销</li>
        </ul>
      `
    },
    {
      id: 'pms-003',
      title: '酒店自助入住一体机',
      clazzCode: 'AL_PMS',
      clazzName: 'PMS酒店行业',
      state: 1,
      cover: PIC.dxalYl,
      content: `
        <h2>方案简介</h2>
        <p>支持 <b>身份证读取、人脸核验、房卡发放、押金退款</b> 全流程的酒店自助终端，配合后台 PMS 实现 24 小时无人值守入住。</p>
        <h3>硬件能力</h3>
        <ul>
          <li>二代证读取 + 公安系统联网核验</li>
          <li>人证比对（活体检测）、可对接派出所一键报警</li>
          <li>RFID/IC/磁卡多协议房卡发卡</li>
          <li>支持微信、支付宝、银联押金预授权</li>
        </ul>
      `
    },
  ],

  AL_SELF: [
    {
      id: 'self-001',
      title: '无人值守自助麻将室 · 智能联网解决方案',
      clazzCode: 'AL_SELF', clazzName: '无人自助', state: 1, cover: PIC.dxalGy,
      content: `
        <h2>项目概述</h2>
        <p>面向社区 / 写字楼 / 棋牌馆的 <b>24 小时无人值守自助麻将室</b>。客户全程小程序操作：约局 → 扫码开门 → 自动开灯通电 → 麻将机自动洗牌计局 → 结束自动断电与结算，0 人工。</p>
        <h3>核心能力</h3>
        <ul>
          <li><b>智能麻将机联网</b>：自动洗牌、自动计分、自动计局，开关机状态实时上报后台</li>
          <li><b>小程序约局</b>：实景选包间 / 拼桌 / 邀请朋友、提前 30 分钟预通风通电</li>
          <li><b>智能门锁 + 客控</b>：扫码 / 人脸开门，灯光 / 空调 / 烧水壶按订单状态联动</li>
          <li><b>茶水零食售卖</b>：包间内智能售货柜 / 自动配送，扫码即取，挂单结算</li>
          <li><b>AI 安全监控</b>：摄像头 + AI 识别久坐 / 烟雾 / 火情 / 异常行为，秒级告警</li>
          <li><b>多店连锁分账</b>：总部统一定价 / 营销，分店独立结算，分销返佣自动到账</li>
        </ul>
        <h3>客户价值</h3>
        <p>典型门店上线 60 天：<b>营业时长从 12 小时拉到 24 小时</b>、坪效提升 1.8 倍、单店仅需 1 名巡检员负责 5–8 个门店保洁补货。</p>
      `
    },
    {
      id: 'self-002',
      title: '无人值守自助茶室 · 高端共享空间',
      clazzCode: 'AL_SELF', clazzName: '无人自助', state: 1, cover: PIC.dxalNy,
      content: `
        <h2>项目概述</h2>
        <p>面向都市白领与社交聚会的 <b>无人值守自助茶室</b>，主打"私密、安静、自助、零打扰"。从约房到结账全程小程序，包间内一键呼叫管家。</p>
        <h3>核心能力</h3>
        <ul>
          <li>小程序约房 / 续单，按小时 / 半天 / 整天计费</li>
          <li>智能门锁、灯光、空调、香薰、背景乐独立可控</li>
          <li>自助茶具 + 茶包售卖柜，扫码取用挂单</li>
          <li>智能煮水壶联网监测水位与温度</li>
          <li>美团 / 抖音卡券一键自助核销</li>
        </ul>
      `
    },
    {
      id: 'self-003',
      title: '无人值守自助台球室 · 24h 智能门店',
      clazzCode: 'AL_SELF', clazzName: '无人自助', state: 1, cover: PIC.gy2,
      content: `
        <h2>项目概述</h2>
        <p>面向校园 / 商圈 / 写字楼周边的 <b>24 小时自助台球室</b>，扫码开台、自动计时、智能球桌灯控、卡券与小时卡灵活组合。</p>
        <h3>核心能力</h3>
        <ul>
          <li>球桌灯独立通电控制，开台秒亮、结束秒灭</li>
          <li>计时计分、超时提醒、定时续杯（茶水）</li>
          <li>积分等级 / 月卡 / 次卡 / 学生卡多营销组合</li>
          <li>顾客自助退台 + 押金自动原路返还</li>
          <li>支持远程值守接管，监控异常事件</li>
        </ul>
      `
    },
    {
      id: 'self-004',
      title: '无人值守自助影院 · 私享包间',
      clazzCode: 'AL_SELF', clazzName: '无人自助', state: 1, cover: PIC.tlMobile,
      content: `
        <h2>项目概述</h2>
        <p><b>无人值守自助影院</b>：私享包间观影、KTV 唱歌、游戏体验三合一。小程序选片选房，包间到点自动开机，结束自动关机，零接触。</p>
        <h3>核心能力</h3>
        <ul>
          <li>实景 3D 选座 / 选片 / 选音响模式</li>
          <li>独立 4K 投影 / 杜比音响 / RGB 氛围灯智能控制</li>
          <li>包间小程序点单（爆米花 / 饮料 / 简餐）</li>
          <li>支持 OTA 团购券、剧本杀拼车券核销</li>
          <li>异常情况一键呼叫远程客服</li>
        </ul>
      `
    },
  ],

  AL_AI: [
    {
      id: 'ai-001',
      title: '行业大模型 · 私有化知识库问答',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.dxalTl,
      content: `
        <h2>方案简介</h2>
        <p>基于开源大模型（Qwen / DeepSeek / GLM / Llama）+ RAG 检索增强，为政企客户搭建 <b>私有化部署的知识库智能问答</b> 系统，数据全程不出内网。</p>
        <h3>能力清单</h3>
        <ul>
          <li>多格式文档解析：PDF / Word / Excel / 扫描件 OCR / 视频字幕抽取</li>
          <li>向量检索 + 重排序（BGE-Rerank），回答附带原文出处与置信度</li>
          <li>多角色权限：部门隔离、文档级 ACL、追问审计日志</li>
          <li>对接企业微信、钉钉、飞书机器人，一键 @智能助手</li>
          <li>支持 GPU / CPU 混合推理，从单机到集群</li>
        </ul>
        <h3>客户价值</h3>
        <p>典型客户上线 2 周，<b>员工查资料效率提升 5×</b>，新员工 onboarding 周期从 30 天缩短到 7 天。</p>
      `
    },
    {
      id: 'ai-002',
      title: 'AI 智能客服 · 多渠道对话中台',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.nyUser,
      content: `
        <h2>方案简介</h2>
        <p>统一接入网站、小程序、公众号、抖音、企微、电话语音等 <b>10+ 渠道</b>，由大模型驱动的智能客服替代 70% 人工坐席。</p>
        <h3>核心特性</h3>
        <ul>
          <li>意图识别 + 多轮对话状态机，支持复杂工单流转</li>
          <li>话术库 / 工单系统无缝衔接，一键转人工</li>
          <li>实时辅助（Agent Assist）：坐席旁挂建议、自动总结</li>
          <li>对话质检与情感分析、流失风险预警</li>
          <li>支持语音 ASR / TTS，合成多种发音人</li>
        </ul>
      `
    },
    {
      id: 'ai-003',
      title: 'AI Agent · 业务流程自动化',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.yl,
      content: `
        <h2>方案简介</h2>
        <p>面向运营、HR、财务、法务等部门的 <b>AI Agent 工作流</b>：自动收单、自动对账、自动写报告、自动催办、自动审阅。</p>
        <h3>已落地场景</h3>
        <ul>
          <li>合同审阅：抽取关键条款、合规校验、风险提示</li>
          <li>简历筛选：批量打分、自动约面、智能 Offer 谈判</li>
          <li>财务对账：发票识别、三单匹配、异常推送</li>
          <li>周报月报：跨 ERP / OA / CRM 取数 + 自动生成</li>
          <li>研报生成：行业 / 个股报告 1 小时出稿</li>
        </ul>
      `
    },
    {
      id: 'ai-004',
      title: '酒店行业 · AI 数字员工矩阵',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.dxalYl,
      content: `
        <h2>方案简介</h2>
        <p>面向酒店集团的 <b>AI 数字员工矩阵</b>：AI 预订专员、AI 退改专员、AI 投诉处理、AI 在线管家全 7×24 在岗。</p>
        <h3>核心能力</h3>
        <ul>
          <li>对接 PMS、CRS、OTA 渠道，自动应答房型 / 价格 / 政策</li>
          <li>个性化推荐：基于用户画像推套餐 / 增值服务</li>
          <li>多语言（中 / 英 / 日 / 韩 / 泰）即时应答，覆盖入境游客</li>
          <li>投诉智能分诊：按情绪强度自动转店长，并生成处理建议</li>
        </ul>
        <h3>客户价值</h3>
        <p>某连锁酒店上线 90 天：<b>夜间咨询响应 0 等待</b>、转化率提升 28%、人工客服人力下降 60%。</p>
      `
    },
    {
      id: 'ai-005',
      title: '医疗影像 · AI 辅助阅片系统',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.dxalNy,
      content: `
        <h2>方案简介</h2>
        <p>基于卷积神经网络 + 多模态大模型的 <b>医学影像辅助阅片</b> 平台，覆盖 CT / MR / X-Ray / 病理切片。</p>
        <h3>核心能力</h3>
        <ul>
          <li>肺结节检测、骨折识别、脑出血定位、糖网筛查</li>
          <li>结构化报告自动生成，医生只需确认与签字</li>
          <li>对接 PACS / HIS，零侵入接入医院信息系统</li>
          <li>本地化模型微调：基于医院历史数据持续学习</li>
        </ul>
      `
    },
    {
      id: 'ai-006',
      title: '工业质检 · 视觉大模型缺陷识别',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.gy1,
      content: `
        <h2>方案简介</h2>
        <p>基于视觉大模型的 <b>工业产品表面缺陷识别</b> 系统，毫秒级响应、缺陷类型可热更新。</p>
        <h3>能力清单</h3>
        <ul>
          <li>支持划痕、凹陷、色差、漏装、错装等数十种缺陷</li>
          <li>少样本学习：每类缺陷 20 张样本即可冷启动</li>
          <li>边缘端部署，单线 60 FPS 实时处理</li>
          <li>缺陷可视化、SPC 报表、追溯到批次 / 工位</li>
        </ul>
      `
    },
    {
      id: 'ai-007',
      title: '政务 12345 · AI 工单理解与派单',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.tlPc,
      content: `
        <h2>方案简介</h2>
        <p>面向政府 12345 热线 / 网格员系统的 <b>AI 工单中枢</b>：自动分类、自动派单、风险预警、热点聚合。</p>
        <h3>核心能力</h3>
        <ul>
          <li>事件多级分类：3000+ 末级类目精度 92%</li>
          <li>责任部门智能匹配，跨部门协作自动通知</li>
          <li>群体性事件预警：地理 / 时间 / 主题聚类</li>
          <li>语音工单实时转写 + 摘要 + 情感分析</li>
        </ul>
      `
    },
    {
      id: 'ai-008',
      title: 'AI 数字人 · 直播带货 / 培训 / 接待',
      clazzCode: 'AL_AI', clazzName: 'AI 落地', state: 1, cover: PIC.tlMobile,
      content: `
        <h2>方案简介</h2>
        <p>提供 <b>2D / 3D / 超写实 AI 数字人</b>，支持电商直播、企业培训、政企接待、新闻播报等场景。</p>
        <h3>能力清单</h3>
        <ul>
          <li>克隆真人形象 + 声音，5 分钟素材即可定制</li>
          <li>实时口型 / 表情 / 手势驱动，唇音误差 &lt; 80ms</li>
          <li>多机位虚拟直播间，绿幕 / 实景一键切换</li>
          <li>对接抖音 / 视频号 / 快手开放平台</li>
        </ul>
      `
    },
  ],

  AL_NY: [
    {
      id: 'ny-001',
      title: '中国农科院 · 智慧农业平台',
      clazzCode: 'AL_NY',
      clazzName: '农业',
      state: 1,
      cover: PIC.nyUser,
      content: '<p>智慧农业平台，覆盖物联网采集、专家诊断、农事追溯。</p>'
    },
    {
      id: 'ny-002',
      title: '专家在线服务系统',
      clazzCode: 'AL_NY',
      clazzName: '农业',
      state: 1,
      cover: PIC.nyExpert,
      content: '<p>专家与农户在线问诊，远程诊断作物病虫害。</p>'
    },
  ],

  AL_YL: [
    {
      id: 'yl-001',
      title: '云大医院 · 医疗信息系统',
      clazzCode: 'AL_YL',
      clazzName: '医疗',
      state: 1,
      cover: PIC.yl,
      content: '<p>面向医院的信息化系统，覆盖门诊、住院、影像。</p>'
    },
  ],

  AL_GY: [
    {
      id: 'gy-001',
      title: '西南水泥 · 工业可视化平台',
      clazzCode: 'AL_GY',
      clazzName: '工业',
      state: 1,
      cover: PIC.gy1,
      content: '<p>面向工业生产场景的数据可视化与设备监控平台。</p>'
    },
    {
      id: 'gy-002',
      title: '生产数据驾驶舱',
      clazzCode: 'AL_GY',
      clazzName: '工业',
      state: 1,
      cover: PIC.gy2,
      content: '<p>面向管理层的生产指标实时驾驶舱。</p>'
    },
  ],

  AL_TL: [
    {
      id: 'tl-001',
      title: '中国铁路 · PC 端调度系统',
      clazzCode: 'AL_TL',
      clazzName: '铁路',
      state: 1,
      cover: PIC.tlPc,
      content: '<p>面向铁路调度的 PC 端管理系统。</p>'
    },
    {
      id: 'tl-002',
      title: '中国铁路 · 移动端巡检 App',
      clazzCode: 'AL_TL',
      clazzName: '铁路',
      state: 1,
      cover: PIC.tlMobile,
      content: '<p>巡检人员现场作业的移动 App。</p>'
    },
  ],
}

const allCases = () => Object.values(CASE_PAGES).flat()

export default {
  // 与 baseData 接口对齐
  getClazz: ({ pcode } = {}) => Promise.resolve({
    code: 200,
    data: { list: CLAZZ_LIST.filter(c => !pcode || c.pcode === pcode) }
  }),
  getPage: ({ clazzCode, pageNum = 1, pageSize = 1000 } = {}) => {
    const list = (CASE_PAGES[clazzCode] || []).slice((pageNum - 1) * pageSize, pageNum * pageSize)
    return Promise.resolve({ code: 200, data: { list } })
  },
  selectInfo: ({ id } = {}) => {
    const detail = allCases().find(c => c.id === id) || {}
    return Promise.resolve({ code: 200, data: detail })
  },
  // 行业解决方案（首页用）
  getIndustries: () => Promise.resolve({
    code: 200,
    data: {
      list: [
        {
          code: 'AI',
          name: 'AI 大模型落地',
          english: 'AI / LLM Solutions',
          desc: '提供大模型私有化部署、RAG 知识库、Agent 工作流、AI 数字人、视觉大模型等企业级 AI 全栈服务。',
          tags: ['LLM 私有化', 'RAG', 'Agent', '数字人', '视觉大模型'],
          highlights: [
            { num: '70%', label: '客服替代率' },
            { num: '100%', label: '数据内网' },
            { num: '8+',  label: '行业 Demo' },
          ],
          accent: '#00E5FF', icon: 'el-icon-cpu',
        },
        {
          code: 'PMS',
          name: 'PMS 酒店行业',
          english: 'Hotel Property Management',
          desc: '面向中小连锁酒店、客栈、民宿提供全流程 PMS、自助入住、渠道分销、AI 数字员工与数据看板。',
          tags: ['前台收银', '渠道直连', '自助入住', 'AI 客房管家', '会员营销'],
          highlights: [
            { num: '35%', label: '人力下降' },
            { num: '3×',  label: '夜间效率' },
            { num: '24h', label: '无人值守' },
          ],
          accent: '#FF4ECD', icon: 'el-icon-house',
        },
        {
          code: 'SELF',
          name: '无人自助门店',
          english: 'Self-Service Stores',
          desc: '面向麻将室 / 茶室 / 台球室 / 影院 / 棋牌等共享空间，提供 IoT 客控 + 小程序约局 + 自动结算的全无人解决方案。',
          tags: ['麻将室', '茶室', '台球', '影院', '智能门控'],
          highlights: [
            { num: '24h', label: '无人营业' },
            { num: '1.8×', label: '坪效提升' },
            { num: '5+',   label: '业态覆盖' },
          ],
          accent: '#31E0A1', icon: 'el-icon-key',
        },
        {
          code: 'NY',
          name: '智慧农业',
          english: 'Smart Agriculture',
          desc: '物联网数据采集、专家 AI 诊断、农事追溯、产销一体化，服务中国农科院等头部客户。',
          tags: ['IoT 采集', 'AI 病虫害诊断', '溯源', '气象预警'],
          highlights: [
            { num: '1000+', label: '设备接入' },
            { num: '92%', label: '识别精度' },
          ],
          accent: '#B6FF3C', icon: 'el-icon-sunny',
        },
        {
          code: 'YL',
          name: '医疗 / 影像',
          english: 'Medical Informatization',
          desc: '面向三甲医院与基层医疗机构的信息系统、AI 影像辅助阅片、远程会诊与智能预问诊。',
          tags: ['HIS', 'PACS', 'AI 阅片', '远程会诊'],
          highlights: [
            { num: '5+', label: '三甲医院' },
            { num: '0.3s', label: '阅片速度' },
          ],
          accent: '#7C5CFF', icon: 'el-icon-first-aid-kit',
        },
        {
          code: 'GY',
          name: '工业可视化',
          english: 'Industry & Vision AI',
          desc: '面向工业生产场景的数据可视化大屏、AI 视觉质检、设备预测性维护与能耗管理。',
          tags: ['大屏', 'AI 质检', '预测维护'],
          highlights: [
            { num: '60FPS', label: '实时质检' },
            { num: '99.5%', label: '识别准确率' },
          ],
          accent: '#FFB547', icon: 'el-icon-set-up',
        },
        {
          code: 'GW',
          name: '政务 / 城市治理',
          english: 'Government & Smart City',
          desc: '12345 热线 AI 派单、AI 网格员、政务问答助手、市域社会治理一网统管。',
          tags: ['AI 派单', '热点聚合', '舆情', '风险预警'],
          highlights: [
            { num: '92%', label: '分类精度' },
            { num: '3000+', label: '末级类目' },
          ],
          accent: '#52DDF4', icon: 'el-icon-office-building',
        },
      ]
    }
  })
}
